/** La pagina «Prove» della console (atlante cap. 489). Gemello: `en.ts`. */
export default {
  titolo: 'Prove',
  sottotitolo: 'Centralino e chatbot da far provare a chi è interessato, senza usare i numeri delle aziende clienti.',
  aggiorna: 'Aggiorna',
  azienda: {
    non_impostata: 'L\'azienda dimostrativa non è ancora impostata: finché manca non si possono creare prove né link.',
    non_pronta: 'I link non funzionano ancora: {{motivo}}.',
    pronta: 'Risponde {{nome}} al numero {{numero}}.',
  },
  elenco: {
    titolo: 'Le prove',
    nuova: 'Nuova prova',
    vuoto: 'Nessuna prova. Creane una per poter mandare il primo link.',
    prova: 'Prova',
    prodotto: 'Prodotto',
    stato: 'Stato',
    lo_chiede_l_assistente: 'Lo chiede l\'assistente',
    pronta: 'Pronta',
    crea_link: 'Crea il link',
    modifica: 'Modifica',
  },
  inviti: {
    titolo: 'I link creati',
    vuoto: 'Nessun link creato.',
    per_chi: 'Per chi',
    senza_nome: 'Senza nome',
    prova: 'Prova',
    scade: 'Scade',
    usato: 'Usato',
    usi: '{{usi}} di {{massimo}}',
    usi_pubblico: '{{usi}}',
    stato: 'Stato',
    prova_eliminata: 'Prova eliminata',
    copia: 'Copia il link',
    revoca: 'Revoca',
    stati: {
      attivo: 'Attivo',
      scaduto: 'Scaduto',
      usi_esauriti: 'Usi finiti',
    },
  },
  dialogo_prova: {
    titolo_nuova: 'Nuova prova',
    titolo_modifica: 'Modifica la prova',
    etichetta: 'Nome della prova',
    descrizione: 'Cosa fa provare',
    missione: 'Missione',
    categoria: 'Prodotto',
    categoria_aiuto: 'Con un prodotto scelto, l\'assistente non lo chiede.',
    messaggio: 'Messaggio già scritto',
    messaggio_aiuto: 'Lo manda la persona toccando il link.',
    attiva: 'Attiva',
    salva: 'Salva la prova',
    annulla: 'Annulla',
  },
  dialogo_invito: {
    titolo: 'Crea il link: {{prova}}',
    nome: 'Per chi (facoltativo)',
    giorni: 'Valido per quanti giorni',
    pubblico: 'Link per il sito: lo usano tutti, finché non lo revochi',
    crea: 'Crea il link',
    annulla: 'Annulla',
    chiudi: 'Chiudi',
    pronto: 'Chi tocca il link apre WhatsApp col messaggio già scritto. Scade il {{giorno}}.',
    qr: 'Codice QR del link',
    copia: 'Copia il link',
  },
  dialogo_revoca: {
    titolo: 'Revocare questo link?',
    testo: 'Da adesso chi lo tocca parla con l\'assistente senza partire da questa prova. Non si può annullare.',
    conferma: 'Revoca il link',
    annulla: 'Annulla',
  },
  messaggi: {
    prova_salvata: 'Prova salvata',
    link_copiato: 'Link copiato',
    link_revocato: 'Link revocato',
    copia_non_riuscita: 'Il browser non ha copiato il link: selezionalo e copialo a mano.',
    errore_generico: 'Il server non ha risposto. Riprova tra poco: se continua, va controllato il suo registro.',
  },
  motivi: {
    whatsapp_spento: 'WhatsApp non è attivo sull\'azienda dimostrativa',
    numero_non_collegato: 'l\'azienda dimostrativa non ha un numero WhatsApp collegato',
    agente_spento: 'l\'assistente dell\'azienda dimostrativa è spento',
    missione_spenta: 'la missione è spenta sull\'azienda dimostrativa',
    prova_spenta: 'la prova è spenta',
    missione_non_valida: 'questa missione non può partire da un link',
    categoria_non_valida: 'l\'azienda dimostrativa non vende questo prodotto',
    azienda_non_impostata: 'l\'azienda dimostrativa non è impostata',
    prova_non_trovata: 'questa prova non esiste più',
    campi_mancanti: 'servono il nome della prova e il messaggio',
    invito_non_trovato: 'questo link non esiste più',
  },
} as const;
